














import Vue from "vue";
import VueMq from "vue-mq";
import { Route } from "vue-router";

import store from "@/store";
import Navigation from "@/parts/common/NavigationBar.vue";
import Footer from "@/parts/common/Footer.vue";
import { UserProfile } from "./api/dto/UserProfile";
import { getAuthCodeFlag, hasAccessToken } from "./jwt";
import router from "./router";

Vue.use(VueMq, {
  breakpoints: {
    sp: 600,
    tab: 1025,
    pc: Infinity,
  },
  defaultBreakpoint: "pc",
});

export default Vue.extend({
  name: "App",
  store,
  components: {
    Navigation,
    Footer,
  },
  watch: {
    $route() {
      this.setMeta(this.$route);
      store.dispatch("updateAuth");
      store.dispatch("updateAccountStatusAndIconUrlInSession");
      // ローカルストレージから番号認証フラグを取得し、sessionストレージのフラグと同期する
      let flag = getAuthCodeFlag();
      store.dispatch("updateValidateFlag", { isValidatedAuthCode: flag });
      // 番号認証画面以外の画面では番号認証済みか否かをチェックする
      if (this.currentPath !== "/login/number/auth" && this.currentPath !== "/login/mail/auth") {
        store.dispatch("checkValidated");
      }
    },
  },
  data() {
    return {
      // 入札設定画面にてヘッダとフッタがチラつくのを防ぐためのフラグ
      isLoaded: false,
      // スクロールバー有無判定用フラグ
      scrollBar: false,
      // モバイル判定用フラグ
      isMobile: false,
    };
  },
  computed: {
    logged() {
      return this.$store.getters.hasAuth;
    },
    currentPath() {
      return this.$route.path;
    },
    loginData(): UserProfile {
      return this.$store.getters.userProfile;
    },
    /**
     * currentNameがnullのときはHeaderを表示しない
     * 初回ロード時、ヘッダのみが表示されるのを防ぐ
     */
    showHeader(): boolean {
      var currentName = this.$route.name;
      if (
        (!this.isLoaded && currentName == "EditTenderSettings") ||
        (!this.isLoaded && currentName == "CreateTenderSettings") ||
        currentName == null
      ) {
        return false;
      }
      return true;
    },
    showFotter(): boolean {
      var currentName = this.$route.name;
      var userCategory = this.loginData.userCategory;
      if (
        currentName == "Login" ||
        currentName == "CorporateLogin" ||
        currentName == "PasswordReissue" ||
        currentName == "PasswordResetting" ||
        currentName == "Signup" ||
        currentName == "CorpInformationForm" ||
        currentName == "CorporateUserValidate" ||
        currentName == "Validate" ||
        currentName == "SettingsMailAddress" ||
        currentName == "SettingsPassword" ||
        currentName == "SettingsPayment" ||
        (!this.isLoaded && currentName == "EditTenderSettings") ||
        (!this.isLoaded && currentName == "CreateTenderSettings") ||
        currentName == null
      ) {
        return false;
      }
      return true;
    },
  },
  methods: {
    setMeta(route: Route) {
      // タイトルを設定
      if(route.meta && route.meta.title) {
        document.title = route.meta.title;
      } else {
        document.title = 'ReviewMarkets';
      }
      // ディスクリプションを設定
      if(route.meta && route.meta.desc) {
        document.querySelector("meta[name='description']")!!.setAttribute('content', route.meta.desc);
      } else {
        document.querySelector("meta[name='description']")!!.setAttribute('content', '');
      }
    },
    showToast(msg: string) {
      // main.jsで読み込んだので this.$toasted で呼び出せる
      this.$toasted.show(msg, {
        // iconPack: 'fontawesome',
        // icon: 'check-circle',
      });
    },
    errorToast(msg: string) {
      // main.jsで読み込んだので this.$toasted で呼び出せる
      this.$toasted.error(msg, {
        iconPack: "fontawesome",
        icon: "fa-exclamation-circle",
      });
    },
    // 入札設定の読み込みが済んでいるか否かを取得する
    loaded(bool: boolean) {
      this.isLoaded = bool;
    },
    hasScrollBar() {
      if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
        this.scrollBar = document.documentElement.scrollHeight > document.documentElement.clientHeight;
      }
    },
  },
  mounted() {
    this.setMeta(this.$route);
    this.hasScrollBar();

    const resizeObserver = new ResizeObserver((el) => {
      this.hasScrollBar();
    });

    resizeObserver.observe(document.documentElement);
  },
});
